import { createFileRoute } from "@tanstack/react-router";

import { ManageAccount } from "@/features/office/manage-account";
import { ConnectGoogleCalendarProvider } from "@/features/office/schedule/_providers/connect-google-calendar-provider";

export const Route = createFileRoute("/office/manage-account")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ConnectGoogleCalendarProvider>
      <ManageAccount />
    </ConnectGoogleCalendarProvider>
  );
}
